import { createReducer, on } from '@ngrx/store';
import * as NewsFeedActions from './newsfeed.actions';
import UserBudget from "../../modals/user.budget";

export type UserBudgetState = {
    isLoaded: boolean;
    budget: UserBudget
    errorMessage?: string;
    lastRewardReceivedByUserName: string;
    lastRewardSentDaysAgo: number;
}

export const initialState: UserBudgetState = {
    isLoaded: false,
    budget: null,
    lastRewardReceivedByUserName: null,
    lastRewardSentDaysAgo: 0
}

const _userBudgetReducer = createReducer(
    initialState,
    on(NewsFeedActions.userBudgetLoaded, (state, { userBudget, isLoaded, lastRewardReceivedByUserName, lastRewardSentDaysAgo }) => {
        return { ...state, budget: userBudget, isLoaded, lastRewardReceivedByUserName, lastRewardSentDaysAgo };
    }),
    on(NewsFeedActions.userBudgetResetCompleted, (state, { userBudget, lastRewardReceivedByUserName, lastRewardSentDaysAgo }) => {
        return { ...state, budget: userBudget, isLoaded: true, lastRewardReceivedByUserName: lastRewardReceivedByUserName ?? state.lastRewardReceivedByUserName, lastRewardSentDaysAgo: lastRewardSentDaysAgo ?? state.lastRewardSentDaysAgo };
    }),
    on(NewsFeedActions.userBudgetLoadingError, (state, { errorMessage }) => {
        return { ...state, isLoaded: false, errorMessage };
    })
);

export function userBudgetReducer(state: UserBudgetState | undefined, action: any): UserBudgetState {
    return _userBudgetReducer(state, action);
}

const _newsFeedLastUpdatedAtReducer = createReducer(
    null as string,
    on(NewsFeedActions.newsFeedLastUpdatedAt, (state, { lastUpdatedAt }) => {
        return lastUpdatedAt;
    })
);

export function newsFeedLastUpdatedAtReducer(state: string | undefined, action: any): string {
    return _newsFeedLastUpdatedAtReducer(state, action);
}